export const mockData = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: { name: "Example Location", id: "0" },
      geometry: {
        coordinates: [
          [
            [150.39478553224092, -30.17398766695071],
            [150.3468831529991, -30.47904630042121],
            [150.70591338225603, -30.520360864174805],
            [151.08288832148855, -30.520382261595046],
            [151.08315494561418, -30.375787483883016],
            [151.0891727559794, -30.174048298908204],
            [151.38155525953442, -30.08613406532561],
            [151.3816481100813, -29.9564952003744],
            [151.26826564476454, -29.92010072280914],
            [150.84994143830812, -29.935505195533764],
            [150.7900376110993, -30.08074546089349],
            [150.39478553224092, -30.17398766695071],
          ],
        ],
        type: "Polygon",
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "1" },
      geometry: {
        coordinates: [
          [
            [146.82106769872047, -31.13527066955099],
            [146.69770045577968, -31.398879147875206],
            [147.02295615131504, -31.43720243821943],
            [147.13511736118625, -31.351038425193757],
            [147.12390197900675, -31.24082393093856],
            [146.9893081913845, -31.21204814733437],
            [146.99491706433793, -30.97193477934833],
            [147.25289512113903, -30.938274875004325],
            [146.8098492780906, -30.84683079114327],
            [146.69208265870805, -30.928641148531618],
            [146.82106769872047, -31.13527066955099],
          ],
        ],
        type: "Polygon",
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "2" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [148.09412517637492, -29.257946150928923],
            [148.0659408321658, -29.259151140469573],
            [148.03802593516195, -29.26275458909646],
            [148.01064741277187, -29.268722044573376],
            [147.98406717428404, -29.276996444750093],
            [147.9585396553821, -29.28749865171207],
            [147.93430942664853, -29.3001281931764],
            [147.91160888687472, -29.31476420476092],
            [147.8906560615468, -29.331266564991164],
            [147.87165252629876, -29.349477213192664],
            [147.8547814744102, -29.369221638755608],
            [147.840205946568, -29.390310528666614],
            [147.82806724009447, -29.41254155869112],
            [147.81848351366526, -29.435701312173915],
            [147.8115486021851, -29.459567309117073],
            [147.80733105495528, -29.483910127010695],
            [147.80587340854632, -29.50849559384626],
            [147.80719170388628, -29.533087032851014],
            [147.811275254986, -29.55744753775991],
            [147.8180866744636, -29.58134225690464],
            [147.82756215860763, -29.604540664060476],
            [147.83961203215515, -29.62681879386514],
            [147.85412155027856, -29.647961419719927],
            [147.8709519525106, -29.667764152411362],
            [147.88994176051534, -29.68603543825808],
            [147.91090830878795, -29.70259843639443],
            [147.93364949457407, -29.71729275585039],
            [147.95794573059143, -29.729976034370395],
            [147.98356208156437, -29.740525342424093],
            [148.0102505631924, -29.74883839758541],
            [148.03775258002003, -29.75483457637579],
            [148.06580147679824, -29.75845571276089],
            [148.09412517637492, -29.759666674731616],
            [148.1224488759516, -29.75845571276089],
            [148.1504977727298, -29.75483457637579],
            [148.17799978955742, -29.74883839758541],
            [148.20468827118543, -29.740525342424093],
            [148.23030462215837, -29.729976034370395],
            [148.25460085817576, -29.71729275585039],
            [148.27734204396185, -29.70259843639443],
            [148.2983085922345, -29.68603543825808],
            [148.31729840023922, -29.667764152411362],
            [148.33412880247127, -29.647961419719927],
            [148.3486383205947, -29.62681879386514],
            [148.3606881941422, -29.604540664060476],
            [148.37016367828625, -29.58134225690464],
            [148.37697509776385, -29.55744753775991],
            [148.38105864886353, -29.533087032851014],
            [148.3823769442035, -29.50849559384626],
            [148.38091929779455, -29.483910127010695],
            [148.3767017505647, -29.459567309117073],
            [148.36976683908458, -29.435701312173915],
            [148.36018311265533, -29.41254155869112],
            [148.3480444061818, -29.390310528666614],
            [148.33346887833963, -29.369221638755608],
            [148.31659782645107, -29.349477213192664],
            [148.297594291203, -29.331266564991164],
            [148.27664146587512, -29.31476420476092],
            [148.2539409261013, -29.3001281931764],
            [148.22971069736772, -29.28749865171207],
            [148.2041831784658, -29.276996444750093],
            [148.17760293997796, -29.268722044573376],
            [148.15022441758785, -29.26275458909646],
            [148.122309520584, -29.259151140469573],
            [148.09412517637492, -29.257946150928923],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "3" },
      geometry: {
        coordinates: [149.51292637922234, -29.3232043695522],
        type: "Point",
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "4" },
      geometry: {
        coordinates: [149.9611504857674, -30.79862937762666],
        type: "Point",
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "5" },
      geometry: {
        coordinates: [149.76482083510973, -30.71670915929598],
        type: "Point",
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "6" },
      geometry: {
        coordinates: [149.77629870564738, -30.441544807639488],
        type: "Point",
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "7" },
      geometry: {
        coordinates: [149.60809120238838, -30.47054768188646],
        type: "Point",
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "8" },
      geometry: {
        coordinates: [146.04715522395958, -30.837197571630227],
        type: "Point",
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "9" },
      geometry: {
        coordinates: [148.08851697600676, -29.51368699978616],
        type: "Point",
      },
    },
    {
      type: "Feature",
      properties: { name: "Example Location", id: "10" },
      geometry: {
        coordinates: [
          [
            [147.5984260191006, -31.124578746075187],
            [147.5984260191006, -31.26368986620433],
            [147.76665780396297, -31.26368986620433],
            [147.76665780396297, -31.124578746075187],
            [147.5984260191006, -31.124578746075187],
          ],
        ],
        type: "Polygon",
      },
    },
  ],
};
